import { useState } from "react";
import ListView from "./ListView.jsx";
import GridView from "./GridView.jsx";
import "../../styles/visualization/entriesSection.css";

const EntriesSection = ({
  entries = [],
  viewMode = "grid",
  loading = false,
  currentFolderPath,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Loading skeleton content
  if (loading) {
    return (
      <div className="folder-entries-section">
        <div className="folder-entries-loading">
          {[...Array(6)].map((_, idx) => (
            <div key={idx} className="folder-entry-skeleton" />
          ))}
        </div>
      </div>
    );
  }
  // Empty state
  if (!entries || entries.length === 0) {
    return (
      <div className="folder-entries-section folder-empty">
        <p>No entries found in this folder.</p>
      </div>
    );
  }

  return (
    <div className="folder-entries-section">
      {viewMode === "list" ? (
        <ListView
          entries={entries}
          hoveredIndex={hoveredIndex}
          setHoveredIndex={setHoveredIndex}
          currentFolderPath={currentFolderPath}
        />
      ) : (
        <GridView entries={entries} currentFolderPath={currentFolderPath} />
      )}
    </div>
  );
};

export default EntriesSection;
